var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-main',[_c('v-row',[_c('v-col',{staticClass:"left",attrs:{"cols":"6"}},[_c('info')],1),_c('v-col',{attrs:{"cols":"6"}},[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }